import React, { FC } from "react";

import { RecommendationsList } from "@components/main/recommendation/RecommendationsList";

interface Component {}

const Component: FC<Component> = () => <RecommendationsList />;

export default Component;
